/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TooltipDirective } from '@sml/utility';
import {IconsComponent} from '@sml/icons'

@Component({
  selector: 'sml-toggle-radio-button',
  imports: [CommonModule,FormsModule, ReactiveFormsModule,IconsComponent,TooltipDirective],
  templateUrl: './toggle-radio-button.component.html',
  styleUrl: './toggle-radio-button.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleRadioButtonComponent),
      multi: true,
    },
  ],
})
export class ToggleRadioButtonComponent<T extends number | string | boolean>
implements ControlValueAccessor  {
@Input() options: Record<string, T> = {};
@Input() name = 'radio-group';
@Input() groupIdentifier = '';
@Input() subheadings: Record<string, string> = {};
@Input() showSubheadings = false;
@Input() inputType: 'radio' | 'checkbox' = 'radio';
@Input() disabledOptions: T[] = [];
@Input() customClass='';
@Input() adjustHeight = false;
@Input() customInputHeight = false;
@Input() showToolTip=false
@Input() iconName: { name: string; sizeClass?: string }[] = [];;
@Input() interactiveTourIcon=false;
@Input() combinedViewWithButton=false;
@Input() notAllowedPointer=false;
@Input() singleColumn=false;
@Input() disabledTooltip='';


value: T | T[] | null = null;
onChange: (value: T | T[]) => void = () => { };
onTouched: () => void = () => { };

getDisabledOption(option: T): boolean {
  return this.disabledOptions.includes(option);
}

writeValue(value: T | T[] | null): void {
  this.value = value;
}

registerOnChange(fn: (value: T | T[]) => void): void {
  this.onChange = fn;
}

registerOnTouched(fn: () => void): void {
  this.onTouched = fn;
}

getEnumKeys(): string[] {
  return Object.keys(this.options).filter((key) => isNaN(Number(key)));
}

isChecked(value: T): boolean {
  if (this.inputType === 'checkbox') {
    return Array.isArray(this.value) && this.value.includes(value);
  }
  return this.value === value;
}

onInputChange(value: T): void {
  if (this.inputType === 'checkbox') {
    const selectedValues = Array.isArray(this.value) ? [...this.value] : [];
    if (selectedValues.includes(value)) {
      this.value = selectedValues.filter((v) => v !== value);
    } else {
      this.value = [...selectedValues, value];
    }
  } else {
    this.value = value;
  }
  this.onChange(this.value);
  this.onTouched();
}
}
